import { DEFAULT_ROAD_DISTANCE } from '../../interfaces/filters';
import { IThunkActionCreator } from '../../types/store';
import { normalizeNameForSearch } from '../../utils/geo';
import { commuteSuggestSort, commuteSuggestUpdater } from '../../utils/roads';
import { getRoadNameVariants, IRoadsFiltered } from './actions';
import { IRoadSuggest } from './';

export function filterRoads(value: string, distance: number = DEFAULT_ROAD_DISTANCE): IThunkActionCreator {
  return (dispatch, getState) => {
    const {
      roads: { currentRoads, regionHasRoads, selectedRoads },
      villageList: { roadData },
    } = getState();

    if (!value || !regionHasRoads) {
      dispatch<IRoadsFiltered>({
        roads: [],
        type: 'RoadsFiltered',
      });

      return;
    }

    const normalizedValue = normalizeNameForSearch(value);
    const filteredRoads = (currentRoads as IRoadSuggest[])
      .filter(road => getRoadNameVariants(road).some(variant => variant.includes(normalizedValue)))
      .map(commuteSuggestUpdater(roadData as Record<number, number>, selectedRoads, distance))
      .sort(commuteSuggestSort);

    dispatch<IRoadsFiltered>({
      roads: filteredRoads,
      type: 'RoadsFiltered',
    });
  };
}
